import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { DatosContrato } from '../models/datos-contrato';
import { switchMap, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/DatosContrato';

@Injectable({
  providedIn: 'root'
})
export class ContratoService {
   
  constructor(private _http: HttpClientService) { }

  getAll(id): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index?id='+id})
  }

  getByPersonalId(personalId: number): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetByPersonalId/' + personalId })
  }

  getByPersonalCurrent(personalId: number): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetByPersonalCurrent/' + personalId })
  }

  getHistoryByPersonalId(personalId: any)
  {
    return this._http.get<any>({ url: baseUrl + '/GetHistoryByPersonalId/' + personalId })
  }

  save(datosContrato: DatosContrato, cortarRegistro: boolean): Observable<any>
  {
    return this._http.post({ url: baseUrl + '/Save/' + cortarRegistro, body: datosContrato });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });
  }

  getFormatoImportacion() {
    const formato = [
      { personal: 0,
        desde: '00/00/0000',
        hasta: '00/00/0000',
        claseContrato: '', 
        fechafinC: '00/00/0000',
        fechaFinPrueba: '00/00/0000',
        periodoPrueba: '',
        horasMensuales: '',
        horasJornadaLaboral: '',
        errores: ['No Completar']}
    ];

    //claseContrato se deben validar que existan

    return formato;
  }
}
